module.exports = __webpack_public_path__ + "img/nt106-04-98.prt.d98c8eb2.jpg";